// import React, { useMemo } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { MdLayers } from 'react-icons/md';
// import PropTypes from 'prop-types';

// import { useSelector } from 'react-redux';
// import { Container, Header, TreeRoot, Card, Empty } from './styles';
// import { opIdiomaCatalogo, SYSTEM_FACES } from '../../lib/idiomaAppOptions';

// function getNavigationLevels(params = {}) {
//   return Object.keys(params)
//     .filter((key) => key.toUpperCase().startsWith('IDN_'))
//     .map((key) => ({
//       codigo: Number(key.toUpperCase().replace('IDN_', '')),
//       id: Number(params[key]),
//     }))
//     .filter((level) => !Number.isNaN(level.codigo) && !Number.isNaN(level.id))
//     .sort((a, b) => a.codigo - b.codigo);
// }

// function getBranchPathByLevels(nodes = [], levels = []) {
//   let currentNodes = Array.isArray(nodes) ? nodes : [];
//   const branchPath = [];

//   levels.forEach((level) => {
//     const found = currentNodes.find(
//       (node) =>
//         Number(node.tipo) === 0 &&
//         Number(node.codigo) === Number(level.codigo) &&
//         Number(node.id) === Number(level.id)
//     );

//     if (found) {
//       branchPath.push(found);
//       currentNodes = Array.isArray(found.itens) ? found.itens : [];
//     }
//   });

//   return branchPath;
// }

// function findPagePath(nodes = [], selectedPageId, currentPath = []) {
//   if (!selectedPageId) return [];

//   const safeNodes = Array.isArray(nodes) ? nodes : [];
//   const safePath = Array.isArray(currentPath) ? currentPath : [];

//   for (let index = 0; index < safeNodes.length; index += 1) {
//     const node = safeNodes[index];
//     const nextPath = [...safePath, node];

//     if (Number(node.tipo) === 1 && Number(node.id) === Number(selectedPageId)) {
//       return nextPath;
//     }

//     if (Array.isArray(node.itens) && node.itens.length > 0) {
//       const found = findPagePath(node.itens, selectedPageId, nextPath);
//       if (found.length > 0) return found;
//     }
//   }

//   return [];
// }

// function getPageNodes(nodes = []) {
//   if (!Array.isArray(nodes)) return [];

//   return nodes.filter((node) => Number(node.tipo) === 1);
// }

// function resolveActiveFaces(data, paramsObj = {}) {
//   const allNodes = Array.isArray(data?.treeView) ? data.treeView : [];
//   const selectedPageId = paramsObj.IDP || paramsObj.idp;

//   const pagePath = findPagePath(allNodes, selectedPageId);
//   const pageBranchPath = pagePath.filter((node) => Number(node.tipo) === 0);

//   if (pageBranchPath.length > 0) {
//     const activeGroup = pageBranchPath[pageBranchPath.length - 1];

//     return {
//       nodes: getPageNodes(activeGroup.itens),
//       branchPath: pageBranchPath,
//     };
//   }

//   const routeBranchPath = getBranchPathByLevels(
//     allNodes,
//     getNavigationLevels(paramsObj)
//   );

//   if (routeBranchPath.length > 0) {
//     const activeGroup = routeBranchPath[routeBranchPath.length - 1];

//     return {
//       nodes: getPageNodes(activeGroup.itens),
//       branchPath: routeBranchPath,
//     };
//   }

//   return {
//     nodes: [],
//     branchPath: [],
//   };
// }

// function clearNavigationParams(params) {
//   Array.from(params.keys()).forEach((key) => {
//     const upperKey = key.toUpperCase();

//     if (
//       upperKey.startsWith('IDN_') ||
//       ['IDP', 'IDI', 'ERP'].includes(upperKey)
//     ) {
//       params.delete(key);
//     }
//   });
// }

// function buildSearch(baseParams, node, branchPath = []) {
//   const params = new URLSearchParams(baseParams);

//   clearNavigationParams(params);

//   const safeBranchPath = Array.isArray(branchPath) ? branchPath : [];

//   safeBranchPath
//     .filter((pathNode) => Number(pathNode.tipo) === 0)
//     .forEach((pathNode) => {
//       params.set(`IDN_${pathNode.codigo}`, pathNode.id);
//     });

//   if (Number(node.tipo) === 1) {
//     params.set('IDP', node.id);
//   }

//   return params.toString();
// }

// function buildTo(pathname, baseParams, node, branchPath = []) {
//   const search = buildSearch(baseParams, node, branchPath);

//   return `${pathname}${search ? `?${search}` : ''}`;
// }

// function FaceCard({ node, baseParams, selectedPageId, branchPath, pathname }) {
//   const selected = Number(selectedPageId) === Number(node.id);

//   return (
//     <Card selected={selected}>
//       <Link to={buildTo(pathname, baseParams, node, branchPath)}>
//         {node.url && <img loading="lazy" src={node.url} alt={node.descricao} />}

//         <span>{node.descricao}</span>
//       </Link>
//     </Card>
//   );
// }

// function SistemaFacesTree({ data, title = 'Faces do sistema' }) {
//   const location = useLocation();

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const { nodes, selectedPageId, baseParams, branchPath } = useMemo(() => {
//     const params = new URLSearchParams(location.search);
//     const paramsObj = Object.fromEntries(params);
//     const activeFaces = resolveActiveFaces(data, paramsObj);

//     return {
//       nodes: activeFaces.nodes,
//       selectedPageId: params.get('IDP') || params.get('idp'),
//       baseParams: params,
//       branchPath: activeFaces.branchPath,
//     };
//   }, [data, location.search]);

//   const hasItems = nodes && nodes.length > 0;

//   return (
//     <Container>
//       <Header>
//         <MdLayers size={18} />
//         <strong>{SYSTEM_FACES[idioma]}</strong>
//       </Header>

//       {!hasItems ? (
//         <Empty>Nenhuma face encontrada para este sistema/subsistema.</Empty>
//       ) : (
//         <TreeRoot>
//           {nodes.map((node) => (
//             <FaceCard
//               key={`${node.tipo}-${node.codigo || 'p'}-${node.id}`}
//               node={node}
//               baseParams={baseParams}
//               selectedPageId={selectedPageId}
//               branchPath={branchPath}
//               pathname={location.pathname}
//             />
//           ))}
//         </TreeRoot>
//       )}
//     </Container>
//   );
// }

// FaceCard.propTypes = {
//   node: PropTypes.instanceOf(Object).isRequired,
//   baseParams: PropTypes.instanceOf(URLSearchParams).isRequired,
//   selectedPageId: PropTypes.string,
//   branchPath: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
//   pathname: PropTypes.string.isRequired,
// };

// FaceCard.defaultProps = {
//   selectedPageId: null,
//   branchPath: [],
// };

// SistemaFacesTree.propTypes = {
//   data: PropTypes.instanceOf(Object).isRequired,
//   title: PropTypes.string,
// };

// SistemaFacesTree.defaultProps = {
//   title: 'Faces do sistema',
// };

// export default SistemaFacesTree;

import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdLayers } from 'react-icons/md';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { Container, Header, TreeRoot, Card, Empty } from './styles';
import { opIdiomaCatalogo, SYSTEM_FACES } from '../../lib/idiomaAppOptions';

function getNavigationLevels(params = {}) {
  return Object.keys(params)
    .filter((key) => key.toUpperCase().startsWith('IDN_'))
    .map((key) => ({
      codigo: Number(key.toUpperCase().replace('IDN_', '')),
      id: Number(params[key]),
    }))
    .filter((level) => !Number.isNaN(level.codigo) && !Number.isNaN(level.id))
    .sort((a, b) => a.codigo - b.codigo);
}

function getBranchPathByLevels(nodes = [], levels = []) {
  let currentNodes = Array.isArray(nodes) ? nodes : [];
  const branchPath = [];

  levels.forEach((level) => {
    const found = currentNodes.find(
      (node) =>
        Number(node.tipo) === 0 &&
        Number(node.codigo) === Number(level.codigo) &&
        Number(node.id) === Number(level.id)
    );

    if (found) {
      branchPath.push(found);
      currentNodes = Array.isArray(found.itens) ? found.itens : [];
    }
  });

  return branchPath;
}

function findPagePath(nodes = [], selectedPageId, currentPath = []) {
  if (!selectedPageId) return [];

  const safeNodes = Array.isArray(nodes) ? nodes : [];
  const safePath = Array.isArray(currentPath) ? currentPath : [];

  for (let index = 0; index < safeNodes.length; index += 1) {
    const node = safeNodes[index];
    const nextPath = [...safePath, node];

    if (Number(node.tipo) === 1 && Number(node.id) === Number(selectedPageId)) {
      return nextPath;
    }

    if (Array.isArray(node.itens) && node.itens.length > 0) {
      const found = findPagePath(node.itens, selectedPageId, nextPath);
      if (found.length > 0) return found;
    }
  }

  return [];
}

function getPageNodes(nodes = []) {
  if (!Array.isArray(nodes)) return [];

  return nodes.filter((node) => Number(node.tipo) === 1);
}

function resolveActiveFaces(data, paramsObj = {}) {
  const allNodes = Array.isArray(data?.treeView) ? data.treeView : [];
  const selectedPageId = paramsObj.IDP || paramsObj.idp;

  const pagePath = findPagePath(allNodes, selectedPageId);
  const pageBranchPath = pagePath.filter((node) => Number(node.tipo) === 0);

  if (pageBranchPath.length > 0) {
    const activeGroup = pageBranchPath[pageBranchPath.length - 1];

    return {
      nodes: getPageNodes(activeGroup.itens),
      branchPath: pageBranchPath,
    };
  }

  const routeBranchPath = getBranchPathByLevels(
    allNodes,
    getNavigationLevels(paramsObj)
  );

  if (routeBranchPath.length > 0) {
    const activeGroup = routeBranchPath[routeBranchPath.length - 1];

    return {
      nodes: getPageNodes(activeGroup.itens),
      branchPath: routeBranchPath,
    };
  }

  return {
    nodes: [],
    branchPath: [],
  };
}

function clearNavigationParams(params) {
  Array.from(params.keys()).forEach((key) => {
    const upperKey = key.toUpperCase();

    if (
      upperKey.startsWith('IDN_') ||
      ['IDP', 'IDI', 'ERP'].includes(upperKey)
    ) {
      params.delete(key);
    }
  });
}

function buildSearch(baseParams, node, branchPath = []) {
  const params = new URLSearchParams(baseParams);

  clearNavigationParams(params);

  const safeBranchPath = Array.isArray(branchPath) ? branchPath : [];

  safeBranchPath
    .filter((pathNode) => Number(pathNode.tipo) === 0)
    .forEach((pathNode) => {
      params.set(`IDN_${pathNode.codigo}`, pathNode.id);
    });

  if (Number(node.tipo) === 1) {
    params.set('IDP', node.id);
  }

  return params.toString();
}

function buildTo(pathname, baseParams, node, branchPath = []) {
  const search = buildSearch(baseParams, node, branchPath);

  return `${pathname}${search ? `?${search}` : ''}`;
}

function FaceCard({ node, baseParams, selectedPageId, branchPath, pathname }) {
  const selected = Number(selectedPageId) === Number(node.id);

  return (
    <Card selected={selected}>
      <Link to={buildTo(pathname, baseParams, node, branchPath)}>
        {node.url && <img loading="lazy" src={node.url} alt={node.descricao} />}

        <span>{node.descricao}</span>
      </Link>
    </Card>
  );
}

function SistemaFacesTree({ data, hideHeader }) {
  const location = useLocation();

  /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );

  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  const { nodes, selectedPageId, baseParams, branchPath } = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const paramsObj = Object.fromEntries(params);
    const activeFaces = resolveActiveFaces(data, paramsObj);

    return {
      nodes: activeFaces.nodes,
      selectedPageId: params.get('IDP') || params.get('idp'),
      baseParams: params,
      branchPath: activeFaces.branchPath,
    };
  }, [data, location.search]);

  const hasItems = nodes && nodes.length > 0;

  return (
    <Container>
      {/**
       * hideHeader: quando o componente é exibido dentro do painel lateral
       * da tela de classificação, o título já é apresentado pelo cabeçalho
       * do painel — evita duplicidade e economiza altura em tablet.
       */}
      {!hideHeader && (
        <Header>
          <MdLayers size={18} />
          <strong>{SYSTEM_FACES[idioma]}</strong>
        </Header>
      )}

      {!hasItems ? (
        <Empty>Nenhuma face encontrada para este sistema/subsistema.</Empty>
      ) : (
        <TreeRoot>
          {nodes.map((node) => (
            <FaceCard
              key={`${node.tipo}-${node.codigo || 'p'}-${node.id}`}
              node={node}
              baseParams={baseParams}
              selectedPageId={selectedPageId}
              branchPath={branchPath}
              pathname={location.pathname}
            />
          ))}
        </TreeRoot>
      )}
    </Container>
  );
}

FaceCard.propTypes = {
  node: PropTypes.instanceOf(Object).isRequired,
  baseParams: PropTypes.instanceOf(URLSearchParams).isRequired,
  selectedPageId: PropTypes.string,
  branchPath: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  pathname: PropTypes.string.isRequired,
};

FaceCard.defaultProps = {
  selectedPageId: null,
  branchPath: [],
};

SistemaFacesTree.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  hideHeader: PropTypes.bool,
};

SistemaFacesTree.defaultProps = {
  hideHeader: false,
};

export default SistemaFacesTree;
